"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1820],{

/***/ 81820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ExpertSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/shared/components/ImageWithOverlayAndChatBubble.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  transform: ",
        ";\n  rotate: 10deg;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ImageWithOverlayAndChatBubble = function(_param) {
    var sizes = _param.sizes, height = _param.height, width = _param.width, variant = _param.variant, props = (0,_object_without_properties/* default */.Z)(_param, [
        "sizes",
        "height",
        "width",
        "variant"
    ]);
    var smUp = (0,useBreakpoints/* useBreakpointUp */._)("sm");
    var isLarge = variant === "compact" ? false : smUp;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundEllipseImage, {
                $isLarge: isLarge,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "",
                    src: "/artifacts/images/shared/contact/background-ellipse.webp",
                    height: height,
                    width: width,
                    sizes: sizes
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                position: "relative",
                borderRadius: "500px",
                overflow: "hidden",
                width: width,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    alt: "",
                    height: height,
                    width: width
                }, props), {
                    sizes: sizes
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                position: "absolute",
                right: isLarge ? 3 : undefined,
                left: isLarge ? undefined : -15,
                bottom: isLarge ? 0 : 5,
                zIndex: 3,
                height: isLarge ? 50 : 35,
                width: isLarge ? 50 : 35,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    height: isLarge ? 50 : 35,
                    alt: "",
                    width: isLarge ? 50 : 35,
                    src: "/artifacts/images/shared/contact/green-chat-bubble.webp",
                    layout: "responsive"
                })
            })
        ]
    });
};
var BackgroundEllipseImage = styled_components_browser_esm["default"].div(_templateObject(), function(param) {
    var $isLarge = param.$isLarge;
    return $isLarge ? "translateX(-3%) translateY(6%) scaleX(1.1) scaleY(1.07)" : "translateX(-5%) translateY(2%) scaleX(1.15) scaleY(1.07)";
});
/* harmony default export */ var components_ImageWithOverlayAndChatBubble = (ImageWithOverlayAndChatBubble);

// EXTERNAL MODULE: ./src/shared/helpers/createSizes.ts
var createSizes = __webpack_require__(99920);
;// CONCATENATED MODULE: ./src/hub/components/ExpertSection.tsx




function ExpertSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px 15px;\n"
    ]);
    ExpertSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: image;\n  width: fit-content;\n  justify-self: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: description;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: title;\n  ",
        " {\n    padding-top: ",
        "px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: cta;\n  ",
        " {\n    padding-bottom: ",
        "px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-areas:\n    'image'\n    'description'\n    'title'\n    'cta';\n  grid-template-columns: 1fr;\n\n  align-items: center;\n  border-radius: 8px;\n  padding: ",
        ";\n\n  ",
        " {\n    padding: ",
        ";\n\n    column-gap: ",
        "px;\n    row-gap: ",
        "px;\n    grid-template-areas:\n      'image title'\n      'image description'\n      'image cta';\n    grid-template-columns: auto 1fr;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 150%;\n  color: ",
        ";\n  text-align: center;\n\n  ",
        " {\n    font-size: 20px;\n    text-align: start;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 20px;\n  text-align: center;\n  ",
        " {\n    font-size: 16px;\n    line-height: 24px;\n    text-align: start;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}








function ExpertSection(_param) {
    var imageSrc = _param.imageSrc, title = _param.title, name = _param.name, description = _param.description, ctaLink = _param.ctaLink, ctaLabel = _param.ctaLabel, boxProps = (0,_object_without_properties/* default */.Z)(_param, [
        "imageSrc",
        "title",
        "name",
        "description",
        "ctaLink",
        "ctaLabel"
    ]);
    var smUp = (0,useBreakpoints/* useBreakpointUp */._)("sm");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        pt: {
            xs: 2,
            sm: 0
        }
    }, boxProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperBox, {
            bgcolor: "#F8F8F8",
            px: 2,
            maxWidth: {
                xs: "clamp(300px, 70vw, 90vw)",
                sm: "none"
            },
            mx: "auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapperBox, {
                    position: "relative",
                    mb: 3,
                    ml: {
                        xs: 0,
                        md: -7
                    },
                    mt: {
                        xs: -3,
                        md: 1
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ImageWithOverlayAndChatBubble, {
                        src: imageSrc,
                        width: smUp ? 180 : 105,
                        height: smUp ? 180 : 105,
                        objectFit: "cover",
                        sizes: (0,createSizes/* createSizes */.H)({
                            xs: "120px",
                            sm: "200px"
                        }),
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWrapperBox, {
                    mb: {
                        xs: 2.2,
                        sm: 0
                    },
                    maxWidth: 400,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        variant: "h5",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DescriptionWrapperBox, {
                    mb: {
                        xs: 2.2,
                        sm: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAWrapperBox, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        display: "flex",
                        justifyContent: {
                            xs: "center",
                            sm: "flex-start"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: ctaLink,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAButton, {
                                variant: "secondary",
                                py: 0,
                                component: "a",
                                rounded: true,
                                target: "_blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                    fontSize: 14,
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "172.5%",
                                    children: ctaLabel
                                })
                            })
                        })
                    })
                })
            ]
        })
    }));
}
var CTAButton = (0,styled_components_browser_esm["default"])(esm.Button)(ExpertSection_templateObject());
var ImageWrapperBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject1());
var DescriptionWrapperBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject2());
var TitleWrapperBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var CTAWrapperBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var WrapperBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.spacing(1, 3, 4, 3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1, 5, 1, 6);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(6);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var Title = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.palette.secondary["400"];
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
});
var Text = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
});


/***/ }),

/***/ 99920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ createSizes; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var system_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35273);


/**
 * Utility function that helps defining the `sizes` property, of the `next/image` component
 * Based on the theme's breakpoints
 */ var createSizes = function(options) {
    var optionsAsEntries = Object.entries(options);
    // Sorting, so it goes from the smallest breakpoint to the biggest. (mobile-first approach)
    var sortedOptionEntries = optionsAsEntries.sort(function(param, param1) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), breakpointKeyA = _param[0], _param1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param1, 1), breakpointKeyB = _param1[0];
        var breakpointA = system_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].breakpoints.values */ .Z.breakpoints.values[breakpointKeyA];
        var breakpointB = system_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].breakpoints.values */ .Z.breakpoints.values[breakpointKeyB];
        if (breakpointA > breakpointB) {
            return -1;
        }
        if (breakpointA === breakpointB) {
            return 0;
        }
        return 1;
    });
    var sizesArray = sortedOptionEntries.map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), breakpointKey = _param[0], size = _param[1];
        return "(min-width: ".concat(system_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].breakpoints.values */ .Z.breakpoints.values[breakpointKey], "px) ").concat(size);
    });
    return sizesArray.join(", ");
};


/***/ })

}]);